import { resolveImagePath } from '@/utils/imageMap';

export function Mini6ProductShowcase() {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-rcallen-primary-blue uppercase font-arial mb-2">
          THE NEW Mini6
        </h2>
        <h3 className="text-xl font-bold text-rcallen-primary-blue uppercase font-arial">
          MULTIFUNCTIONAL INDICATOR
        </h3>
      </div>

      {/* Main Content Layout */}
      <div className="flex flex-col lg:flex-row gap-8">
        
        {/* Product Image */}
        <div className="lg:w-1/2">
          <div className="bg-gray-50 rounded-lg p-6 text-center">
            <img
              src={resolveImagePath('/images/small_pics/Mini 6.jpg')}
              alt="Mini6 MULTIFUNCTIONAL INDICATOR"
              className="w-full max-w-md mx-auto rounded-lg shadow-md"
            />
            
            {/* Mini6 Logo */}
            <div className="mt-6 flex justify-center">
              <img
                src={resolveImagePath('/images/Mini6 logo.png')}
                alt="Mini6 Logo"
                className="h-16 object-contain"
              />
            </div>
            
            {/* Certification Badge */}
            <div className="mt-4">
              <div className="inline-block bg-rcallen-primary-blue text-white px-4 py-2 rounded-lg text-sm font-bold font-arial">
                SIMPLE SAFE CERTIFIED
              </div>
            </div>
          </div>
        </div>

        {/* Product Description and Features */}
        <div className="lg:w-1/2">
          
          {/* Product Description */}
          <div className="mb-6">
            <p className="text-rcallen-black font-arial leading-relaxed">
              The <span className="font-bold">Mini6</span> indicator is a new addition to 
              <span className="font-bold"> RC Allen's</span> groundbreaking line of digital instruments. 
              It offers all the instrumentation of a traditional Six Pack in one clean, customizable 
              and easy to read presentation. The Mini6 is a totally self-contained, reliable, 
              solid-state instrument. This easy to install indicator comes equipped with an internal 
              battery backup providing an exceptional level of redundancy to any aircraft.
            </p>
          </div>

          {/* Features List - Left Column */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <ul className="space-y-2 text-sm font-arial text-rcallen-black">
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>CUSTOMIZABLE DISPLAY FEATURES</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>SELECTABLE HEADING TYPE</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>MULTI-VOLT OPERATION</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>TOTALLY SELF-CONTAINED</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>EASY INSTALLATION</span>
                </li>
              </ul>
            </div>
            
            {/* Features List - Right Column */}
            <div>
              <ul className="space-y-2 text-sm font-arial text-rcallen-black">
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>FITS STANDARD PANEL CUTOUT</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>INTERNAL BATTERY BACKUP</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>RELIABLE SOLID STATE</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>FULLY FAA CERTIFIED</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>TWO YEAR LIMITED WARRANTY</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Battery Backup Logo */}
          <div className="mt-6 flex justify-center">
            <img
              src={resolveImagePath('/images/Internal Battery Backup Logo small.jpg')}
              alt="Internal Battery Backup"
              className="h-12 object-contain"
            />
          </div>

          {/* More Information Link */}
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center justify-center">
              <a 
                href="/downloads" 
                className="inline-flex items-center gap-3 text-rcallen-primary-blue hover:text-blue-700 transition-colors"
              >
                <div className="w-8 h-8 bg-rcallen-primary-blue text-white rounded-full flex items-center justify-center text-sm">
                  i
                </div>
                <div className="text-center">
                  <div className="text-xs font-arial">CLICK HERE FOR</div>
                  <div className="text-xs font-arial font-bold">MORE INFORMATION</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}